import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleLeft,
  faCircleUser,
  faHouse,
  faClipboardList,
  faTrophy,
  faCartShopping,
  faRightFromBracket,
  faDoorOpen,
  faGear,
  faUsers,
  faCircleCheck,
  faMagnifyingGlass,
  faListCheck,
  faGift,
  faChildren,
  faChartBar,
  faPlus,
  faMinus,
  faPenToSquare,
  faTrashCan,
  faXmark,
  faCircleXmark,
  faCheck,
  faLock,
  faKey,
  faCopy,
  faCircleQuestion,
  faCamera,
  faImage,
  faEye,
  faEyeSlash,
  faClock,
  faBed,
  faCalendarDays,
  faStopwatch,
  faFire,
  faStar,
  faCrown,
  faCoins,
  faShieldHalved,
  faWandMagicSparkles,
  faScrollOld,
  faGamepadModern,
  faArrowLeft,
  faChevronRight,
  faSparkles,
  faFloppyDisk,
  faTriangleExclamation,
  faCircleInfo,
  faBadgeCheck,
  faStars,
  faPartyHorn,
  faRocket,
  faBolt,
  faThumbsUp,
  faThumbsDown,
  faRotate,
  faFamilyPants,
  faSquareCheck,
  faHourglass,
  faUserPlus,
  faSpinner,
  faDownload,
  faCommentDots,
  faMedal,
  faEnvelope,
  faArrowUpRightFromSquare,
  faBell,
  faBellSlash,
  faVolumeHigh,
  faVolumeXmark,
  faBug,
  faHandshake,
  faPeopleGroup,
  faBagShopping,
} from '@awesome.me/kit-e916efbc87/icons/duotone/solid';

import {
  faAngleLeft as fasAngleLeft,
  faCircleUser as fasCircleUser,
  faHouse as fasHouse,
  faHouseChimney as fasHouseChimney,
  faClipboardList as fasClipboardList,
  faTrophy as fasTrophy,
  faCartShopping as fasCartShopping,
  faDoorOpen as fasDoorOpen,
  faGear as fasGear,
  faCircleCheck as fasCircleCheck,
  faMagnifyingGlass as fasMagnifyingGlass,
  faListCheck as fasListCheck,
  faGift as fasGift,
  faChildren as fasChildren,
  faChartBar as fasChartBar,
  faCrosshairs as fasCrosshairs,
  faCrown as fasCrown,
  faTreasureChest as fasTreasureChest,
  faEllipsisVertical as fasEllipsisVertical,
  faLeftFromBracket as fasLeftFromBracket,
} from '@awesome.me/kit-e916efbc87/icons/classic/solid';

library.add(
  faAngleLeft,
  faCircleUser,
  fasAngleLeft,
  fasCircleUser,
  fasHouse,
  fasHouseChimney,
  fasClipboardList,
  fasTrophy,
  fasCartShopping,
  fasDoorOpen,
  fasGear,
  fasCircleCheck,
  fasMagnifyingGlass,
  fasListCheck,
  fasGift,
  fasChildren,
  fasChartBar,
  fasCrosshairs,
  fasCrown,
  fasTreasureChest,
  fasEllipsisVertical,
  fasLeftFromBracket,
  faHouse,
  faClipboardList,
  faTrophy,
  faCartShopping,
  faRightFromBracket,
  faDoorOpen,
  faGear,
  faUsers,
  faCircleCheck,
  faMagnifyingGlass,
  faListCheck,
  faGift,
  faChildren,
  faChartBar,
  faPlus,
  faMinus,
  faPenToSquare,
  faTrashCan,
  faXmark,
  faCircleXmark,
  faCheck,
  faLock,
  faKey,
  faCopy,
  faCircleQuestion,
  faCamera,
  faImage,
  faEye,
  faEyeSlash,
  faClock,
  faBed,
  faCalendarDays,
  faStopwatch,
  faFire,
  faStar,
  faCrown,
  faCoins,
  faShieldHalved,
  faWandMagicSparkles,
  faScrollOld,
  faGamepadModern,
  faArrowLeft,
  faChevronRight,
  faSparkles,
  faFloppyDisk,
  faTriangleExclamation,
  faCircleInfo,
  faBadgeCheck,
  faStars,
  faPartyHorn,
  faRocket,
  faBolt,
  faThumbsUp,
  faThumbsDown,
  faRotate,
  faFamilyPants,
  faSquareCheck,
  faHourglass,
  faUserPlus,
  faSpinner,
  faDownload,
  faCommentDots,
  faMedal,
  faEnvelope,
  faArrowUpRightFromSquare,
  faBell,
  faBellSlash,
  faVolumeHigh,
  faVolumeXmark,
  faBug,
  faHandshake,
  faPeopleGroup,
  faBagShopping
);

export {
  faAngleLeft,
  faCircleUser,
  faHouse,
  faClipboardList,
  faTrophy,
  faCartShopping,
  faRightFromBracket,
  faDoorOpen,
  faGear,
  faUsers,
  faCircleCheck,
  faMagnifyingGlass,
  faListCheck,
  faGift,
  faChildren,
  faChartBar,
  faPlus,
  faMinus,
  faPenToSquare,
  faTrashCan,
  faXmark,
  faCircleXmark,
  faCheck,
  faLock,
  faKey,
  faCopy,
  faCircleQuestion,
  faCamera,
  faImage,
  faEye,
  faEyeSlash,
  faClock,
  faBed,
  faCalendarDays,
  faStopwatch,
  faFire,
  faStar,
  faCrown,
  faCoins,
  faShieldHalved,
  faWandMagicSparkles,
  faScrollOld,
  faGamepadModern,
  faArrowLeft,
  faChevronRight,
  faSparkles,
  faFloppyDisk,
  faTriangleExclamation,
  faCircleInfo,
  faBadgeCheck,
  faStars,
  faPartyHorn,
  faRocket,
  faBolt,
  faThumbsUp,
  faThumbsDown,
  faRotate,
  faFamilyPants,
  faSquareCheck,
  faHourglass,
  faUserPlus,
  faSpinner,
  faDownload,
  faCommentDots,
  faMedal,
  faEnvelope,
  faArrowUpRightFromSquare,
  faBell,
  faBellSlash,
  faVolumeHigh,
  faVolumeXmark,
  faBug,
  faHandshake,
  faPeopleGroup,
  faBagShopping,
};
